const INITIAL_STATE = {
  userList: {},
  user: {},
  errors: {},
}
  
const authorizedUser = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_AUTHORIZED_USER':
    return { ...state, ...INITIAL_STATE, userList: action.data }
  case 'GET_AUTHORIZED_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_AUTHORIZED_USER':
    return { ...state, ...INITIAL_STATE, user: action.data }
  case 'ADD_AUTHORIZED_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_AUTHORIZED_USER':
    return { ...state, ...INITIAL_STATE, user: action.data }
  case 'DELETE_AUTHORIZED_USER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default authorizedUser;